var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtpInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_645_4156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8957 8.9375C48.2942 8.9375 56.3487 12.2738 62.2874 18.2125C68.226 24.1511 71.5623 32.2056 71.5623 40.6042C71.5623 49.0027 68.226 57.0572 62.2874 62.9959C56.3487 68.9345 48.2942 72.2708 39.8957 72.2708C31.4971 72.2708 23.4426 68.9345 17.504 62.9959C11.5653 57.0572 8.229 49.0027 8.229 40.6042C8.229 32.2056 11.5653 24.1511 17.504 18.2125C23.4426 12.2738 31.4971 8.9375 39.8957 8.9375Z",
    fill: "url(#paint0_radial_645_4156)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8956 10.5374C31.9214 10.5374 24.2738 13.7051 18.6352 19.3437C12.9966 24.9823 9.82891 32.6299 9.82891 40.6041C9.82891 48.5782 12.9966 56.2258 18.6352 61.8644C24.2738 67.503 31.9214 70.6707 39.8956 70.6707C47.8697 70.6707 55.5173 67.503 61.1559 61.8644C66.7945 56.2258 69.9622 48.5782 69.9622 40.6041C69.9622 32.6299 66.7945 24.9823 61.1559 19.3437C55.5173 13.7051 47.8697 10.5374 39.8956 10.5374ZM16.3725 17.081C22.6112 10.8423 31.0727 7.3374 39.8956 7.3374C48.7184 7.3374 57.1799 10.8423 63.4186 17.081C69.6574 23.3197 73.1622 31.7812 73.1622 40.6041C73.1622 49.4269 69.6574 57.8884 63.4186 64.1272C57.1799 70.3659 48.7184 73.8707 39.8956 73.8707C31.0727 73.8707 22.6112 70.3659 16.3725 64.1272C10.1338 57.8884 6.62891 49.4269 6.62891 40.6041C6.62891 31.7812 10.1338 23.3197 16.3725 17.081Z",
    fill: "url(#paint1_radial_645_4156)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0669 35.3959C35.0669 34.5122 35.7832 33.7959 36.6669 33.7959H40.0002C40.8839 33.7959 41.6002 34.5122 41.6002 35.3959V54.7709C41.6002 55.6546 40.8839 56.3709 40.0002 56.3709C39.1166 56.3709 38.4002 55.6546 38.4002 54.7709V36.9959H36.6669C35.7832 36.9959 35.0669 36.2796 35.0669 35.3959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0669 55.3959C35.0669 54.5122 35.7832 53.7959 36.6669 53.7959H43.3336C44.2172 53.7959 44.9336 54.5122 44.9336 55.3959C44.9336 56.2796 44.2172 56.9959 43.3336 56.9959H36.6669C35.7832 56.9959 35.0669 56.2796 35.0669 55.3959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1666 26.9959C39.8201 26.9959 40.3499 26.4661 40.3499 25.8126C40.3499 25.159 39.8201 24.6292 39.1666 24.6292C38.513 24.6292 37.9832 25.159 37.9832 25.8126C37.9832 26.4661 38.513 26.9959 39.1666 26.9959ZM37.1499 25.8126C37.1499 24.6988 38.0528 23.7959 39.1666 23.7959C40.2803 23.7959 41.1832 24.6988 41.1832 25.8126C41.1832 26.9263 40.2803 27.8292 39.1666 27.8292C38.0528 27.8292 37.1499 26.9263 37.1499 25.8126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1668 27.8873C40.3128 27.8873 41.2418 26.9583 41.2418 25.8123C41.2418 24.6663 40.3128 23.7373 39.1668 23.7373C38.0208 23.7373 37.0918 24.6663 37.0918 25.8123C37.0918 26.9583 38.0208 27.8873 39.1668 27.8873Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_645_4156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.7533 137.874) rotate(-124.286) scale(199.872 501.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_645_4156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.677 142.788) rotate(-124.286) scale(209.971 527.133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_645_4156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpInfo);
export default __webpack_public_path__ + "static/media/otp-info.f6232ab802421809c31506bf4db8f116.svg";
export { ForwardRef as ReactComponent };